import { logout } from '../services/authService';

/**
 * Fetch wrapper with automatic auth error handling
 * Catches 401 errors and redirects to login
 */
export async function authFetch(
  url: string,
  options?: RequestInit
): Promise<Response> {
  const response = await fetch(url, options);

  // Handle token expiration / unauthorized
  if (response.status === 401) {
    console.warn('Authentication failed - redirecting to login');
    await logout();
    window.location.href = '/login';
    throw new Error('Authentication required');
  }

  return response;
}
